import React,{useEffect, useRef} from 'react'
import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useAppData } from '../../../../../context/AppDataContext';
import { Print } from '@mui/icons-material';




function InventoryTransactionList() {

  
  const {inventoryTransactionList,getInventoryTransactionList} = useAppData();
  const {companyDD, projectLocationDD,  productDD, vendorDD,getDDDataById} = useAppData();
  const gridRef = useRef();
  

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},

        {headerName: "Company", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(companyDD,params.data.companyId);
            return _data.label;
          }
        },

        {headerName: "Vendor Name", width:200,
          valueGetter:params=>{
            if(params.data.vendorId){
              let _data = getDDDataById(vendorDD,params.data.vendorId);
              return _data.label;
            } else {
              return "------"
            }
            
          }
        },

        {headerName: "Location", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(projectLocationDD,params.data.locationId);
            return _data.label;
          }
        },

        {headerName: "Product Name", width:200,
          valueGetter:params=>{
            let _data = getDDDataById(productDD,params.data.productId);
            return _data.label;
          }
        },
        

        {headerName: "Transaction Type", width:200,
          valueGetter:params=>{
           if(params.data.transactionType === 1 ){
            return "New Inventry Added";
           }
           if(params.data.transactionType === 2 ){
            return "Inventry Billed";
           }
           if(params.data.transactionType === 3 ){
            return "Restocked / Removed From Invoice";
           }
          }
        },
        
        {headerName: "qty", width:200,
          valueGetter:params=>{
           if(params.data.transactionType === 1 ){
            return "+"+params.data.qty;
           }
           if(params.data.transactionType === 2 ){
            return "-"+params.data.qty;
           }
           if(params.data.transactionType === 3 ){
            return "+"+params.data.qty;
           }
          }
        },
        
        

        {field:"cost",headerName: "Cost"},

        {field:"refId",headerName: "Ref Id"},
        {field:"receiveDate",headerName: "Receiving Date"},
        {field:"receivedBy",headerName: "Received By"},
         
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
        <div className='row'>
            <div className='col-md-6'><h4>Inventory Transaction</h4></div>
            <div className='col-md-6'><button className='btn btn-outline-primary float-end mb-2' onClick={onBtnExport}><Print/> Export</button></div>
            <div className='col-md-12'>
                <div className="ag-theme-alpine" style={{height: 400}}>
                    <AgGridReact
                        ref={gridRef}
                        rowData={inventoryTransactionList}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={true}
                        onGridReady={getInventoryTransactionList}
                    />
                </div>
            </div>
        </div>
    )
}

export default InventoryTransactionList